@if (fileData.file_type === 'image' || fileData.file_type === 'video') {
<div class="chat-msg-image" (click)="playMedia(fileData)">
  @if (fileData.thumb_file_path) {
  <img [src]="dataUrl$ | async" [className]="classStyle" />
  }
  <div class="image-hover" (click)="secureFileDownLoad(fileData)">
    <div class="pos-relative">
      <small class="font-clr-grey is-size-7">{{
        fileData.file_size | fileSize
      }}</small>
      @if (!fileData.startFileDownLoad) {
      <i class="fa fa-download image-download"></i>
      } @if (fileData.startFileDownLoad) {
      <i class="fa fa-circle-o-notch fa-spin image-download has-text-link"></i>
      }
    </div>
  </div>
  @if (fileData.file_type === 'video') {
  <div class="video-play">
    <i class="fa fa-play-circle"></i>
  </div>
  }
  <!-- <p *ngIf="fileData.message !== 'undefined' && fileData.message !== 'null'">{{fileData.message}}</p> -->
</div>
} @if (fileData.file_type !== 'image' && fileData.file_type !== 'video') {
<div class="audio-file">
  <article class="media">
    @if (fileData.file_type === 'audio') {
    <div class="media-left play-btn" (click)="playMedia(fileData)">
      <p class="image is-24x24">
        <img
          class=""
          src="../../../../assets/images/file_types/play-button.png"
        />
      </p>
    </div>
    } @if (fileData.file_type !== 'audio') {
    <div class="media-left">
      <p class="image is-32x32">
        <img
          class=""
          src="../../../../assets/images/file_types/{{ fileData.file_ext }}.png"
        />
      </p>
    </div>
    }
    <div class="media-content">
      <div class="content">
        <span class="file-name-msg" title="{{ fileData.file_id }}">{{
          fileData.file_id
        }}</span>
      </div>
      <nav class="level is-mobile">
        <div class="level-left">
          <a class="level-item">
            <small class="font-clr-grey is-size-7">{{
              fileData.file_size | fileSize
            }}</small>
          </a>
          <a class="level-item">
            @if (!fileData.startFileDownLoad) {
            <i
              class="pi pi-download audio-download"
              (click)="secureFileDownLoad(fileData)"
            ></i>
            } @if (fileData.startFileDownLoad) {
            <i
              class="fa fa-circle-o-notch fa-spin image-download has-text-link"
            ></i>
            }
          </a>
        </div>
      </nav>
    </div>
  </article>
</div>
} @if (fileData.message !== 'undefined' && fileData.message !== 'null') {
<p [innerHTML]="fileData.message | linkify">
  <!-- {{fileData.message}} -->
</p>
}
